export const UNAVAILABLE = {
  GENERAL: 'Sorry, this project is currently unavailable',
  INTERESTED: 'The project you expressed interest in has been placed on hold. It will be available soon. The research team will reach out if you are eligible. Thank you for your understanding and ongoing support.',
  LINK: {
    PATH: 'View All My Matches',
    URL: '/dashboard',
  },
};
